import axios from 'axios'

export const getAllPermissions = (params) => {
  return axios.get('/permissions/by-role', {params: params})
}

export const getPermission = (id, params) => {
  return axios.get('/permissions/' + id, {params: params})
}

export const createPermission = (data) => {
  return axios.post('/permissions', data)
}

export const editPermission = (id, data) => {
  return axios.put('/permissions/' + id, data)
}

export const deletePermission = (id) => {
  return axios.delete('/permissions/' + id)
}

export const getAllPermissionHelpers = () => {
  return axios.get('/helpers/permissions')
}



// WEBPACK FOOTER //
// ./src/api/permissions.js